import React, { useState } from 'react';
import { Button, Card, List, message, Modal, Typography, Popover, Badge, Divider, Space } from 'antd';
import {
    SwapOutlined, ThunderboltOutlined, DeleteOutlined, EyeOutlined, ShoppingCartOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const SeccionVentasEspera = ({ carrito, setCarrito, setVentaActivaEnEspera, ventasEnEspera, saveEspera, deleteEspera, setSeccionActual }) => {
    
    const recuperarVentaNube = (venta) => {
        if (carrito.length > 0) return message.warning("El carrito actual no está vacío. Vacíalo o pausa la venta actual primero.");

        setCarrito(venta.carrito);
        setVentaActivaEnEspera({ id: venta.id, nombre_referencia: venta.nombre_referencia });
    };

    const renombrarVentaEnEspera = (id, nuevoNombre) => {
        const nombreLimpio = nuevoNombre?.trim();
        if (!nombreLimpio) return;

        const ventaExistente = ventasEnEspera.find(v => v.id === id);

        if (ventaExistente) {
            if (nombreLimpio === ventaExistente.nombre_referencia) return;
            saveEspera.mutate({ ...ventaExistente, id: id, nombre_referencia: nombreLimpio }, {
                onSuccess: () => message.success("Nombre actualizado"),
                onError: () => message.error("Error al actualizar el nombre")
            });
        }
    };

    const eliminarVentaEspera = (id) => {
        Modal.confirm({
            title: '¿Eliminar esta venta en espera?',
            content: 'Esta acción no se puede deshacer.',
            okText: 'Sí, eliminar',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                deleteEspera.mutate(id, {
                    onSuccess: () => message.success("Venta eliminada"),
                });
            },
        });
    };

    const ContenidoVistazoRapido = ({ productos = [] }) => (
        <div style={{ width: '280px', maxHeight: '300px', overflowY: 'auto', padding: '5px' }}>
            <Text strong style={{ fontSize: '13px', color: '#0f172a', display: 'block', marginBottom: '10px' }}>
                <ShoppingCartOutlined style={{ marginRight: '5px' }} /> Contenido del pedido
            </Text>
            {productos.map((item, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', borderBottom: '1px dashed #e2e8f0', paddingBottom: '8px' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Badge count={item.numItems} style={{ backgroundColor: '#f1f5f9', color: '#475569', boxShadow: 'none' }} />
                        <Text style={{ fontSize: '12px', color: '#334155', maxWidth: '140px' }} ellipsis>{item.nombre}</Text>
                    </div>
                    <Text strong style={{ fontSize: '12px', color: '#0f172a' }}>
                        ${(item.precioVenta * item.numItems).toLocaleString('es-CO')}
                    </Text>
                </div>
            ))}
            {productos.length === 0 && <Text type="secondary" style={{ fontSize: '12px' }}>No hay detalles disponibles.</Text>}
        </div>
    );

    return (
        <div style={{ padding: '0 10px 10px 0', height: 'calc(100vh - 180px)', overflowY: 'auto', overflowX: 'hidden' }}>
            
            <div style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 100, padding: '15px 0 20px 0', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f1f5f9' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ width: '6px', height: '22px', backgroundColor: '#22BABB', borderRadius: '10px' }}></div>
                    <Title level={4} style={{ margin: 0, color: '#1e293b', letterSpacing: '-0.5px' }}>
                        Ventas en Espera
                    </Title>
                </div>
            </div>

            {ventasEnEspera.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', background: '#f8fafc', borderRadius: '20px', border: '2px dashed #e2e8f0', marginTop: '20px' }}>
                    <div style={{ background: '#fff', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <SwapOutlined style={{ fontSize: '24px', color: '#cbd5e1' }} />
                    </div>
                    <Title level={5} style={{ color: '#64748b', marginBottom: '4px' }}>Todo al día</Title>
                    <Text type="secondary">No tienes ventas pendientes por procesar.</Text>
                </div>
            ) : (
                <div style={{ padding: '10px' }}>
                    <List
                        grid={{ gutter: 20, xs: 1, sm: 2, md: 3, lg: 3, xl: 4 }}
                        dataSource={ventasEnEspera}
                        renderItem={(venta) => {
                            const cantArticulos = venta.carrito?.reduce((acc, item) => acc + (item.numItems || 1), 0) || 0;

                            return (
                                <List.Item>
                                    <Card
                                        bordered={false}
                                        styles={{ body: { padding: '0px' } }}
                                        style={{
                                            borderRadius: '16px',
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.04)',
                                            background: '#ffffff',
                                            border: '1px solid #e2e8f0',
                                            overflow: 'hidden',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <div style={{ height: '6px', width: '100%', background: 'linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%)' }}></div>
                                        
                                        <div style={{ padding: '20px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                                                <div>
                                                    <Space size="small" style={{ marginBottom: '4px' }}>
                                                        <ThunderboltOutlined style={{ color: '#f59e0b', fontSize: '12px' }} />
                                                        <Text type="secondary" style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase' }}>
                                                            {venta.fecha?.split('T')[0] || 'Hoy'}
                                                        </Text>
                                                    </Space>
                                                    <Typography.Text
                                                        editable={{ onChange: (val) => renombrarVentaEnEspera(venta.id, val) }}
                                                        style={{ color: '#0f172a', fontWeight: '900', fontSize: '18px', display: 'block', lineHeight: '1.2' }}
                                                    >
                                                        {venta.nombre_referencia}
                                                    </Typography.Text>
                                                </div>

                                                <Button
                                                    type="text"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => eliminarVentaEspera(venta.id)}
                                                    style={{ marginTop: '-4px', marginRight: '-8px' }}
                                                />
                                            </div>

                                            <div style={{
                                                background: '#f8fafc',
                                                borderRadius: '12px', 
                                                padding: '12px 16px', 
                                                marginBottom: '20px', 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                border: '1px dashed #cbd5e1'
                                            }}>
                                                <div>
                                                    <Text style={{ fontSize: '11px', color: '#64748b', display: 'block' }}>Total a cobrar</Text>
                                                    <Text style={{ fontSize: '22px', fontWeight: '900', color: '#0f172a' }}>
                                                        ${Math.round(venta.total).toLocaleString('es-CO')}
                                                    </Text>
                                                </div>

                                                <Popover 
                                                    content={<ContenidoVistazoRapido productos={venta.carrito} />} 
                                                    title={null} 
                                                    trigger="click" 
                                                    placement="bottomRight"
                                                >
                                                    <Button 
                                                        shape="circle" 
                                                        icon={<EyeOutlined />} 
                                                        style={{ background: '#e0f2fe', color: '#0284c7', border: 'none', boxShadow: '0 2px 4px rgba(2, 132, 199, 0.1)' }}
                                                    />
                                                </Popover>
                                            </div>

                                            <Button
                                                type="primary"
                                                block
                                                onClick={() => {
                                                    recuperarVentaNube(venta);
                                                    setSeccionActual('principal');
                                                }}
                                                style={{ 
                                                    backgroundColor: '#22BABB', 
                                                    height: '45px',
                                                    borderRadius: '10px', 
                                                    fontWeight: '800',
                                                    fontSize: '14px',
                                                    boxShadow: '0 4px 6px -1px rgba(34, 186, 187, 0.25)'
                                                }}
                                            >
                                                RECUPERAR VENTA
                                            </Button>
                                        </div>
                                    </Card>
                                </List.Item>
                            );
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default SeccionVentasEspera;